(function () {
  'use strict';

  function boot() {
    var roots = document.querySelectorAll('.cs-root');
    roots.forEach(initSection);
  }

  function initSection(root) {
    var imgs = Array.from(root.querySelectorAll('.cs-frame-img'));
    var dots = Array.from(root.querySelectorAll('.cs-dot'));
    var wrap = root.querySelector('.cs-phone-wrap');

    if (imgs.length < 2) return;

    var interval = parseInt(root.dataset.interval, 10) || 3500;
    var current = 0;

    setInterval(function () {
      var next = (current + 1) % imgs.length;

      imgs[current].classList.remove('cs-active');
      imgs[next].classList.add('cs-active');

      if (dots[current]) dots[current].classList.remove('cs-dot--active');
      if (dots[next]) dots[next].classList.add('cs-dot--active');

      wrap.classList.add('cs-glare--sweep');
      setTimeout(function () {
        wrap.classList.remove('cs-glare--sweep');
      }, 700);

      current = next;
    }, interval);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
